import { Context, useContext } from 'react';

import { BreadcrumbContext } from '.';

interface BreadcrumbType {
  key: string;
  label: string;
  path: string;
  isParam: boolean;
}

interface BreadcrumbContextType {
  breadcrumbs: BreadcrumbType;
  setParamLabel: (paramKey: string, value: string) => void;
}

function useBreadcrumbs() {
  const context = useContext<BreadcrumbContextType>(
    BreadcrumbContext as unknown as Context<BreadcrumbContextType>,
  );

  return context;
}

export default useBreadcrumbs;
